import { render, staticRenderFns } from "./PreciosVigentesNewOrEdit.vue?vue&type=template&id=46d1e6ba&"
import script from "./PreciosVigentesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./PreciosVigentesNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports